module.exports = __webpack_public_path__ + "static/img/02450_4.e3f3fb1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/02450_4.jpg
// module id = XEHZ
// module chunks = 1